export default __webpack_public_path__ + "assets/eye.c19b9e35.png";